var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgIcSoundOff = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.346 10.994 6.8 8.45a.8.8 0 1 1 1.131-1.132l16.77 16.77a.8.8 0 1 1-1.132 1.13l-3.454-3.453v2.993a.75.75 0 0 1-1.192.606l-5.916-4.31h-3.6a2.846 2.846 0 0 1-2.845-2.847V13.84a2.847 2.847 0 0 1 2.783-2.846zm9.27 9.27v3.02l-4.922-3.587a.75.75 0 0 0-.442-.144H9.409a1.346 1.346 0 0 1-1.347-1.346V13.84c0-.744.603-1.347 1.347-1.347h1.436l7.771 7.772zM15.236 9.37l1.048 1.093 2.332-1.699v4.133l1.5 1.565V7.289a.75.75 0 0 0-1.192-.606z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcSoundOff);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };